import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LichSuDangNhapService } from './lich-su-dang-nhap.service';
import { Router } from '@angular/router';
import { LichSuDangNhap} from './lich-su-dang-nhap';
import { AuthService } from '../../services/auth.service';

declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'vnpt-su-co',
    templateUrl: './lich-su-dang-nhap.component.html',
    providers: [LichSuDangNhapService, LichSuDangNhap]
})
export class LichSuDangNhapComponent implements OnInit {
    title: string = "Lịch sử đăng nhập cá nhân"
    listItem: LichSuDangNhap[] = [];
    
    fromDate:string;
    toDate: string;
    today = new Date();
    
    paging: number = 1;
    totalCount: number = 0;
    totalPages: number = 1;
    total: number;
    page: number;
    keyword: string = '';
    size: number = 10;
    
    success: boolean = false;
    error: boolean = false;
    status: boolean = false;
    successMessage: string = "";
    errorMessage: string = "";
    statusMessage: string = "";    

    errorPop: boolean = false;
    statusPop: boolean = false;
    messagePop: string = "";

    constructor(private service: LichSuDangNhapService,
        private router: Router,
        private titleService: Title,
        public auth: AuthService) {
    }
    transform(value: any): any {
        if (value) {
            var date = value instanceof Date ? value : new Date(value);
            return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
            //return DateFormatter.format(date, 'pt', 'dd/MM/yyyy');
        }
    }
    createRange(number) {
        let items = [];
        for (var i = 1; i <= number; i++) {
            items.push(i);
        }
        return items;
    }

    ngOnInit() {
        this.titleService.setTitle('Lịch sử' + this.title);
        this.keyword = "";
        this.fromDate = this.transform(new Date(this.today.getFullYear(), this.today.getMonth(), 1));
        this.toDate = this.transform(new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate()+1));

       $(function () {
            $('.datetimepicker').datetimepicker({ format: 'DD/MM/YYYY' });
        });
        this.GetList(this.paging);
    }


    search() {
        this.GetList(this.paging);
    }
    onChangeDate(){
        this.GetList(this.paging);
    }
    
    // hàm thực thi tìm kiếm khi người dùng nhấn nút Enter sau gõ ký tự ở ô tìm kiếm
    eventHandler(keyCode) {
        if(keyCode.key == "Enter") {
            this.search();
        }
    }
    // Lấy danh sách từ Stored Procedure phân trang
    GetList(paging: number) {
        this.ShowAlert("Đang load dữ liệu đăng nhập ...", "status");
        this.service.GetMyLoginHistory(paging,this.size,this.fromDate,this.toDate)
            .subscribe(
            (data) => {
                this.HideAlert("status");
                this.listItem = data;
                if (this.listItem.length !== 0) {
                    // tổng records trong list cấp đơn vị
                    this.paging = paging;
                    this.totalCount = (data[0]).TotalRows;
                    this.totalPages = Math.ceil(this.totalCount / this.size); // tính tổng số trang cần phân dựa vào tổng records

                } else {
                    if (paging > 1) {
                        this.GetList(paging-1);
                    } else {
                        this.totalPages = 0;
                    }
                }

            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    ShowAlert(message: string, option: string, pop: boolean = false)
    {
        if(pop) {
            if (option == "error") {
                this.messagePop = message;
                this.errorPop = true;
                //setTimeout(() => this.errorPop = false, 3000);
            }
            else {
                this.messagePop = message;
                this.statusPop = true;
            }
        }
        else {            
            if (option == "success") {
                this.successMessage = message;
                this.success = true;                
                setTimeout(() => this.success = false, 3000);
            }
            else if (option == "error") {
                this.errorMessage = message;
                this.error = true;                
                //setTimeout(() => this.error = false, 3000);
            }
            else {
                this.statusMessage = message;
                this.status = true;
            }
        }
    }

    HideAlert(option: string, pop: boolean = false)
    {
        if(pop) {
            if (option == "error")
                this.errorPop = false;
            else                
                setTimeout(() => this.statusPop = false, 1000);
        }
        else {
            if (option == "success")
                this.success = false;
            else if (option == "error")
                this.error = false;
            else
                setTimeout(() => this.status = false, 1000);            
        }        
    }

}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/he-thong/lich-su-dang-nhap/lich-su-dang-nhap.component.ts